import React, { useContext, useState } from "react";
import {
  Modal,
  Form,
  Select,
  Typography,
  message,
  Button,
} from "antd";
import { callContext } from "../../../../../../App";
import { piopiy, piopiyDialUser } from "../../../../../../utils/piopiy";
import { getUUID } from "../../../../../../_helpers/utils";

const { Title } = Typography;
const { Option } = Select;

const CallModal = ({ contacts, name, open, close }) => {
  const { setMobileNumber } = useContext(callContext);
  const telecmiUser = localStorage.getItem("selectedTelecmiUserId");

  const [selectedPhone, setSelectedPhone] = useState(contacts[0].phone);

  const handleCall = () => {
    if (!telecmiUser) {
      message.error("Can't place call, Login to telecmi account to continue");
      return;
    }

    if (!selectedPhone) {
      message.warning("Please select a contact number first");
      return;
    }

    const uuid = getUUID();
    let mobileNumber = "91" + selectedPhone;
    setMobileNumber(mobileNumber);

    piopiyDialUser(piopiy, mobileNumber, uuid, "Groups", mobileNumber);
  };

  return (
    <Modal
      title={<Title level={4}>Call {name ? name : "Customer"}</Title>}
      visible={open} 
      onCancel={close}
      footer={null}
    >
      <Form layout="vertical">
        <Form.Item label="Select Contact Number">
          <Select
            placeholder="Choose a phone number"
            onChange={(value) => setSelectedPhone(value)}
            value={selectedPhone}
          >
            {contacts?.map((contact, index) => (
              <Option key={index} value={contact.phone}>
                {contact.phone}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Button
          type="primary"
          block
          disabled={!contacts || contacts.length === 0}
          onClick={handleCall}
        >
          Call Customer
        </Button>
      </Form>
    </Modal>
  );
};

export default CallModal;
